import * as moment from 'moment';
import * as React from 'react';
import JuridicalPerson from 'src/entities/JuridicalPerson';

export interface Props {
  person: JuridicalPerson;
}

const ShowJuridicalProfileComponent: React.StatelessComponent<Props> = (props: Props) => {

  return (
    <div>
      <p className="f-s-20 f-w-100">Datos personales:</p>
      <p>
        <strong>Recuerda, los datos que se muestran deben ser los mismos que aparecen en tu NIF o NIE: </strong>
      </p>

      <div>
        <div className="row">
          <div className="col-sm-6">
            <p>
              <strong>Compañia: </strong>
              {props.person.displayName}
            </p>
          </div>
          <div className="col-sm-6">
            <p>
              <strong>Dirección de la oficina: </strong>
              {props.person.officeAddress}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <p>
              <strong>CIF: </strong>
              {props.person.cifNumber}
            </p>
          </div>
          <div className="col-sm-6">
            <p>
              <strong>Email corporativo: </strong>
              {props.person.corporateEmail}
            </p>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-sm-6">
          <p>
            <strong>Nombre: </strong>
            {props.person.name}
          </p>
        </div>
        <div className="col-sm-6">
          <p>
            <strong>Apellido/s: </strong>
            {
              props.person.surname
            }
          </p>
        </div>
        <div className="col-sm-6">
          <p>
            <strong>NIF: </strong>
            {props.person.idNumber}
          </p>
        </div>
        <div className="col-sm-6">
          <p>
            <strong>Fecha de caducidad NIF: </strong>
            {props.person.idExpirationDate ?
              moment.utc(props.person.idExpirationDate).format('DD-MM-YYYY') :
              null
            }
          </p>
        </div>
        <div className="col-sm-6">
          <p>
            <strong>Fecha de nacimiento: </strong>
            {props.person.birthDate ?
              moment.utc(props.person.birthDate).format('DD-MM-YYYY') :
              null
            }
          </p>
        </div>
        <div className="col-sm-6">
          <p>
            <strong>Email: </strong>
            {props.person.email}
          </p>
        </div>
        <div className="col-sm-6">
          <p>
            <strong>Móvil: </strong>
            {props.person.phoneNumber}
          </p>
        </div>
      </div>
      <div className="gap-10"/>
      <div className="row">
        <div className="col-sm-6">
          <p>
            <strong>Dirección: </strong>
            {props.person.address}
          </p>
        </div>
        <div className="col-sm-6">
          <p>
            <strong>Código postal: </strong>
            {props.person.zipCode}
          </p>
        </div>
        <div className="col-sm-6">
          <p>

            <strong>Ciudad: </strong>
            {props.person.city}
          </p>
        </div>
        <div className="col-sm-6">
          <p>
            <strong>Provincia: </strong>
            {props.person.province}
          </p>
        </div>
        <div className="col-sm-6">
          <p>
            <strong>País: </strong>
            {props.person.country}
          </p>
        </div>
        <div className="col-sm-6">
          <p>
            <strong>Nacionalidad: </strong>
            {props.person.nationality}
          </p>
        </div>
      </div>
      <div className="gap-10"/>
      <div className="row">
        <div className="col-sm-6">
          <p>
            <strong>Profesión: </strong>
            {props.person.occupation}
          </p>
        </div>
        <div className="col-sm-6">
          <p>
            <strong>Estado civil: </strong>
            {props.person.maritalStatus}
          </p>
        </div>
        <div className="col-sm-6">
          <p>

            <strong>Estado económico matrimonial: </strong>
            {props.person.maritalEconomicStatus}
          </p>
        </div>
        <div className="col-sm-6">
          <p>
            <strong>Origen de los fondos: </strong>
            {props.person.maritalPropertyRegime}
          </p>
        </div>
      </div>
      <div className="gap-20"/>
      {
        props.person.spouse ?
          (
            <div>
              <p className="f-s-20 f-w-100">
                Datos de su conyuge:
              </p>
              <div className="gap-20"/>
              <div className="row">
                <div className="col-sm-6">
                  <p>
                    <strong>Nombre: </strong>
                    {props.person.spouse.name}
                  </p>
                </div>
                <div className="col-sm-6">
                  <p>
                    <strong>Apellidos: </strong>
                    {props.person.spouse.surname}
                  </p>
                </div>
                <div className="col-sm-6">
                  <p>
                    <strong>NIF: </strong>
                    {props.person.spouse.idNumber}
                  </p>
                </div>
                <div className="col-sm-6">
                  <p>
                    <strong>Email: </strong>
                    {props.person.spouse.email}
                  </p>
                </div>
              </div>
              <div className="gap-20"/>
            </div>
          ) :
          null
      }
    </div>
  );
};

export default ShowJuridicalProfileComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/project-formalization/partials/confirm-profile/ShowJuridicalProfile.component.tsx